var _style, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleFirebase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 95.39 131.07",
    style: {
      enableBackground: "new 0 0 95.39 131.07"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#FFA000;} .st1{fill:#F57C00;} .st2{fill:#FFCA28;} .st3{fill:#FFFFFF;fill-opacity:0.2;} .st4{opacity:0.2;fill:#A52714;enable-background:new ;} .st5{fill:url(#b_1_);}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.05,105.75L16.18,2.52c0.2-1.27,1.18-2.26,2.44-2.48s2.52,0.4,3.13,1.53l16.68,31.12l6.65-12.66 c0.51-0.98,1.53-1.59,2.64-1.59s2.12,0.61,2.64,1.59l45.02,85.72L0.05,105.75L0.05,105.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.78,65.54L38.43,32.68L0.05,105.75L55.78,65.54z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.39,105.75L83.03,29.29c-0.19-1.1-0.97-2-2.03-2.34s-2.22-0.06-3.01,0.73L0.05,105.75l43.12,24.18 c2.71,1.51,6.01,1.51,8.71,0L95.39,105.75L95.39,105.75z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M83.03,29.29c-0.19-1.1-0.97-2-2.03-2.34s-2.22-0.06-3.01,0.73L62.52,43.19L50.36,20.03 c-0.51-0.98-1.53-1.59-2.64-1.59s-2.12,0.61-2.64,1.59l-6.65,12.66L21.75,1.57c-0.6-1.13-1.87-1.75-3.13-1.53s-2.25,1.22-2.44,2.48 L0.05,105.75H0l0.05,0.06l0.42,0.21l77.49-77.58c0.79-0.79,1.95-1.08,3.02-0.74s1.85,1.24,2.03,2.35l12.25,75.77l0.12-0.07 L83.03,29.29L83.03,29.29z M0.19,105.61L16.18,3.26c0.19-1.27,1.18-2.27,2.44-2.48s2.52,0.4,3.13,1.53l16.68,31.12l6.65-12.66 c0.51-0.98,1.53-1.59,2.64-1.59s2.12,0.61,2.64,1.59l11.92,22.66L0.19,105.61L0.19,105.61z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M51.89,129.2c-2.71,1.51-6.01,1.51-8.71,0L0.16,105.09l-0.1,0.66l43.12,24.18c2.71,1.51,6.01,1.51,8.71,0 l43.5-24.18l-0.11-0.69L51.89,129.2L51.89,129.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -243.4794,
    y1: 345.2798,
    x2: -242.4362,
    y2: 344.521,
    gradientTransform: "matrix(95 0 0 -130.9998 23127.4414 45253.9336)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "b",
    className: "st5",
    d: "M82.91,29.3c-0.19-1.1-0.97-2-2.02-2.34c-1.06-0.34-2.21-0.06-3,0.73L62.47,43.2L50.35,20.05 c-0.51-0.98-1.53-1.59-2.63-1.59s-2.11,0.61-2.63,1.59l-6.63,12.66L21.84,1.6c-0.6-1.13-1.86-1.75-3.12-1.53s-2.24,1.22-2.43,2.48 L0.22,105.73l42.97,24.17c2.7,1.51,5.99,1.51,8.68,0l43.34-24.17L82.91,29.3L82.91,29.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleFirebase);
export default __webpack_public_path__ + "static/media/google-firebase.2032586ca6c0a4074c62cffd16b28343.svg";
export { ForwardRef as ReactComponent };